import {DAY_MS, iso, makeShareToken, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

// "All green" demo: installed, activated recently, plenty of validity and
// plenty of data left - ~10% of validity elapsed, ~85% of data remaining.
// Every indicator (ring, expiry bar, pill, status card) should read healthy.
function dates() {
    return {
        activatedAt: iso(-3 * DAY_MS),
        expiresAt: iso(-3 * DAY_MS + 30 * DAY_MS),
        salesDate: iso(-3 * DAY_MS - 60 * 60 * 1000)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 8.5, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 14.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Data Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 10, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 8.5, sizeUnit: "GB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-30 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-30 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Data Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 10, sizeUnit: "GB"},
                availableBalance: {sizeValue: 8.5, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 8.5, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
